import isUndefined from 'lodash/isUndefined';
import $hnxApi from './api';

const $hnxDictionaryProvider = function () {
	const $config = {
		requestPath: '/Dictionary'
	};
	
	return {
		$config,
		
		__cache: {
			regular: {},
			short: {}
		},

		get (name, shortForm, preventCaching) {
			const prop = shortForm ? 'short' : 'regular';
			if (preventCaching) {
				return this.refresh(name, shortForm);
			}
			const promise = this.__cache[prop][name];
			return isUndefined(promise) ? this.refresh(name, shortForm) : promise;
		},

		refresh (name, shortForm) {
			const prop = shortForm ? 'short' : 'regular';
			return this.__cache[prop][name] = $hnxApi.core.dictionary(name, shortForm).then(data => data.payload);
		},

		clear (name, shortForm) {
			const prop = shortForm ? 'short' : 'regular';
			delete this.__cache[prop][name];
		},

		clearAllShort () {
			this.__cache.short = {};
		},

		clearAllRegular () {
			this.__cache.regular = {};
		},

		clearAll () {
			this.__cache.regular = {};
			this.__cache.short = {};
		}
	};
}();

export default $hnxDictionaryProvider;
